import { getUserInfo } from '@/api/AAccountBind'
import store from './index'
import { Module, getModule, VuexModule, Mutation, Action } from 'vuex-module-decorators'

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'login',
})
class LoginModule extends VuexModule {
  url = ''
  userid = ''

  get isLogined() {
    return !!this.userid
  }

  get userId() {
    return this.userid
  }

  @Mutation
  reset() {
    this.url = ''
    this.userid = ''
  }

  @Mutation
  setUrl(url: string) {
    this.url = url
  }

  @Mutation
  setUserId(id: string) {
    this.userid = id
  }

  @Action
  async loadUserInfo(target: string) {
    let res: any = {}
    try {
      res = await getUserInfo(target)
      console.log(res)
      this.context.commit('setUserId', res.student_vo.user_id)
    } catch (e) {
      this.context.commit('setUrl', e.textData)
    }
  }
}

export default getModule(LoginModule)
